/**
 *  ? url pada submenu menggunakan naming routes
 */

export default [
  // Presensi & Perwalian
  {
    icon: "BookIcon",
    menu: "KRS & Perwalian",
    url: "dosen-krs",
    group: "Presensi & Perwalian",
  },
  {
    icon: "CheckCircleIcon",
    menu: "Kehadiran",
    url: "dosen-kehadiran",
    group: "Presensi & Perwalian",
  },

  // Pengajaran & Perkuliahan
  {
    icon: "BookOpenIcon",
    menu: "Kurikulum",
    url: "dosen-kurikulum",
    group: "Pengajaran & Perkuliahan",
  },
  {
    icon: "FileTextIcon",
    menu: "Nilai Mahasiswa",
    url: "dosen-nilai-mahasiswa",
    group: "Pengajaran & Perkuliahan",
  },
  {
    icon: "ShieldCheckIcon",
    menu: "Turnitin Mahasiswa",
    url: "dosen-turnitin-mahasiswa",
    group: "Pengajaran & Perkuliahan",
  },
  {
    icon: "AwardIcon",
    menu: "Validasi Ijazah",
    url: "dosen-validasi-ijazah",
    group: "Pengajaran & Perkuliahan",
  },

  // Tridharma & Publikasi
  {
    icon: "BriefcaseIcon",
    menu: "Penelitian",
    url: "dosen-penelitian",
    group: "Tridharma & Publikasi",
  },
  {
    icon: "HeartIcon",
    menu: "Pengabdian",
    url: "dosen-pengabdian",
    group: "Tridharma & Publikasi",
  },
  {
    icon: "FileTextIcon",
    menu: "Data Publikasi",
    url: "dosen-publikasi",
    group: "Tridharma & Publikasi",
  },
  {
    icon: "HelpCircleIcon",
    menu: "Bantuan Publikasi",
    url: "dosen-bantuan-publikasi",
    group: "Tridharma & Publikasi",
  },

  // Administrasi & Layanan
  {
    icon: "FolderIcon",
    menu: "Administrasi",
    url: "dosen-administrasi",
    group: "Administrasi & Keuangan",
  },
  {
    icon: "CreditCardIcon",
    url: "dosen-slip-gaji",
    menu: "Slip Gaji",
    group: "Administrasi & Keuangan",
  },
  {
    icon: "GlobeIcon",
    menu: "SISTER",
    url: "dosen-sister",
    group: "Integrasi & Kerjasama",
  },
  {
    icon: "Share2Icon",
    menu: "Kerjasama",
    url: "dosen-kerjasama",
    group: "Integrasi & Kerjasama",
  },
];
